import { useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const INITIAL_FORM = {
  nombre_padre: '',
  nombre_estudiante: '',
  grado: '',
  telefono: '',
  email: '',
  mensaje: ''
};

const GRADES = ['K', '1ro', '2do', '3ro', '4to', '5to', '6to', '7mo', '8vo', '9no', '10mo', '11mo', '12mo'];
const GRADE_LABELS = {
  K: 'Kindergarten', '1ro': '1er Grado', '2do': '2do Grado', '3ro': '3er Grado',
  '4to': '4to Grado', '5to': '5to Grado', '6to': '6to Grado', '7mo': '7mo Grado',
  '8vo': '8vo Grado', '9no': '9no Grado', '10mo': '10mo Grado', '11mo': '11mo Grado', '12mo': '12mo Grado'
};

const inputClass =
  'w-full px-4 py-3 bg-stone-50/50 border border-stone-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#43b6b8]/20 focus:border-[#43b6b8]';

export const AdmisionForm = () => {
  const [formData, setFormData] = useState(INITIAL_FORM);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      await axios.post(`${API}/admissions/inquiry`, formData);
      setSubmitStatus('success');
      setFormData(INITIAL_FORM);
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="py-20 md:py-28 bg-[#F3F0EA]" data-testid="formulario-section">
      <div className="max-w-3xl mx-auto px-6 sm:px-8 md:px-12">
        <div className="text-center mb-12">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#d3b163] mb-4 block">Comienza Hoy</span>
          <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight text-stone-900 mb-4">
            Solicita información
          </h2>
          <p className="text-base text-stone-700">
            Completa el formulario y nos pondremos en contacto en las próximas 24 horas.
          </p>
        </div>

        <div className="bg-white p-8 md:p-10 rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.04)]">
          <form onSubmit={handleSubmit} data-testid="admission-form">
            <div className="space-y-6">
              <div>
                <label htmlFor="nombre_padre" className="block text-sm font-medium text-stone-900 mb-2">
                  Nombre del Padre/Madre o Encargado *
                </label>
                <input
                  type="text" id="nombre_padre" name="nombre_padre"
                  value={formData.nombre_padre} onChange={handleChange} required
                  data-testid="input-nombre-padre" className={inputClass}
                />
              </div>

              <div>
                <label htmlFor="nombre_estudiante" className="block text-sm font-medium text-stone-900 mb-2">
                  Nombre del Estudiante *
                </label>
                <input
                  type="text" id="nombre_estudiante" name="nombre_estudiante"
                  value={formData.nombre_estudiante} onChange={handleChange} required
                  data-testid="input-nombre-estudiante" className={inputClass}
                />
              </div>

              <div>
                <label htmlFor="grado" className="block text-sm font-medium text-stone-900 mb-2">
                  Grado *
                </label>
                <select
                  id="grado" name="grado"
                  value={formData.grado} onChange={handleChange} required
                  data-testid="select-grado" className={inputClass}
                >
                  <option value="">Selecciona un grado</option>
                  {GRADES.map((g) => (
                    <option key={g} value={g}>{GRADE_LABELS[g]}</option>
                  ))}
                </select>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="telefono" className="block text-sm font-medium text-stone-900 mb-2">
                    Teléfono *
                  </label>
                  <input
                    type="tel" id="telefono" name="telefono"
                    value={formData.telefono} onChange={handleChange} required
                    data-testid="input-telefono" className={inputClass}
                  />
                </div>
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-stone-900 mb-2">
                    Email *
                  </label>
                  <input
                    type="email" id="email" name="email"
                    value={formData.email} onChange={handleChange} required
                    data-testid="input-email" className={inputClass}
                  />
                </div>
              </div>

              <div>
                <label htmlFor="mensaje" className="block text-sm font-medium text-stone-900 mb-2">
                  Mensaje (opcional)
                </label>
                <textarea
                  id="mensaje" name="mensaje"
                  value={formData.mensaje} onChange={handleChange} rows="4"
                  data-testid="textarea-mensaje" className={inputClass}
                  placeholder="Cuéntanos sobre las necesidades específicas de tu hijo..."
                ></textarea>
              </div>

              {submitStatus === 'success' && (
                <div className="p-4 bg-green-50 border border-green-200 rounded-xl" data-testid="success-message">
                  <p className="text-green-800 text-sm">
                    ¡Gracias! Tu solicitud ha sido recibida. Nos pondremos en contacto contigo pronto.
                  </p>
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="p-4 bg-red-50 border border-red-200 rounded-xl" data-testid="error-message">
                  <p className="text-red-800 text-sm">
                    Hubo un error al enviar tu solicitud. Por favor, intenta nuevamente o llámanos al (787) 362-5354.
                  </p>
                </div>
              )}

              <button
                type="submit" disabled={isSubmitting}
                data-testid="submit-admission-form"
                className="w-full bg-[#d3b163] hover:bg-[#b89548] text-white px-8 py-4 rounded-full font-semibold transition-all disabled:opacity-50 disabled:cursor-not-allowed active:scale-95 shadow-md"
              >
                {isSubmitting ? 'Enviando...' : 'Enviar Solicitud'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};
